import { Components, Theme } from '../../material';
import { borderRadius, ElevationStep } from '../tokens';

const getElevationStyles = (theme: Theme) => (elevation: ElevationStep) => {
  const { background, shadow } = theme.palette.elevation[elevation];

  return {
    boxShadow: shadow,
    backgroundImage:
      background === 'none'
        ? background
        : `linear-gradient(${background}, ${background})`,
  };
};

export const MuiPaper: Components<Theme>['MuiPaper'] = {
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      ...(!ownerState?.square && {
        borderRadius: borderRadius.abs(theme.shape.borderRadius, 'l'),
      }),
    }),
    elevation0: ({ theme }) => getElevationStyles(theme)(0),
    elevation1: ({ theme }) => getElevationStyles(theme)(0),
    elevation2: ({ theme }) => getElevationStyles(theme)(2),
    elevation3: ({ theme }) => getElevationStyles(theme)(2),
    elevation4: ({ theme }) => getElevationStyles(theme)(4),
    elevation5: ({ theme }) => getElevationStyles(theme)(4),
    elevation6: ({ theme }) => getElevationStyles(theme)(6),
    elevation7: ({ theme }) => getElevationStyles(theme)(6),
    elevation8: ({ theme }) => getElevationStyles(theme)(8),
    elevation9: ({ theme }) => getElevationStyles(theme)(8),
    elevation10: ({ theme }) => getElevationStyles(theme)(8),
    elevation11: ({ theme }) => getElevationStyles(theme)(8),
    elevation12: ({ theme }) => getElevationStyles(theme)(12),
    elevation13: ({ theme }) => getElevationStyles(theme)(12),
    elevation14: ({ theme }) => getElevationStyles(theme)(12),
    elevation15: ({ theme }) => getElevationStyles(theme)(12),
    elevation16: ({ theme }) => getElevationStyles(theme)(12),
    elevation17: ({ theme }) => getElevationStyles(theme)(12),
    elevation18: ({ theme }) => getElevationStyles(theme)(12),
    elevation19: ({ theme }) => getElevationStyles(theme)(12),
    elevation20: ({ theme }) => getElevationStyles(theme)(12),
    elevation21: ({ theme }) => getElevationStyles(theme)(12),
    elevation22: ({ theme }) => getElevationStyles(theme)(12),
    elevation23: ({ theme }) => getElevationStyles(theme)(12),
    elevation24: ({ theme }) => getElevationStyles(theme)(24),
  },
};
